import { AppArea } from './@types'

/**
 * Точка входа в воронку — короткий путь, привязанный к funnel area.
 *
 * Маркетинговые ссылки ведут на `path` (например, `/survey/wb`); роут рендерит
 * лендинг, а конкретная area резолвится из префикса пути в рантайме
 * (см. `getFunnelPrefixFromPath` в `src/store/location.js`). Поэтому точке входа
 * достаточно знать свой `path` и целевую `area`.
 *
 *   Текущий запуск (app): /survey/app → воронка glp-app
 *
 * Воронка glp-wb депрекейтнута (см. docs/glp-wb-removal-plan.md); её бывший вход
 * `/wb` редиректится на `/app` в src/router/index.js.
 *
 * Чтобы добавить новую точку входа, достаточно одной строки здесь
 * (+ соответствующая area в `src/funnels/areas`).
 */
type EntryPoint = {
	/** Абсолютный путь точки входа внутри base `/survey/` (напр. `/wb`). */
	path: string
	/** Slug funnel area, в которую ведёт точка входа. */
	area: AppArea
	/**
	 * Имя роута. Основная (первая) точка входа держит имя `landing` — на него
	 * ссылаются fallback-навигации (`LandingView`, `OnboardingView`,
	 * `Redirect.vue`).
	 */
	name: string
}

export const ENTRY_POINTS: EntryPoint[] = [
	{ path: '/app', area: 'glp-app', name: 'landing' },
	{ path: '/dm', area: 'glp-dm', name: 'glp-dm-landing' },
]
